export const ERROR_CATEGORY_NOT_FOUND = 'FetchError:ERROR_CATEGORY_NOT_FOUND';
export const ERROR_PARTNER_NOT_FOUND = 'FetchError:ERROR_PARTNER_NOT_FOUND';
